// @flow
import React from 'react';
import { Link } from 'react-router';
import './SimulationPreviewPanel.scss';

const completeIcon = 'complete-icon fa fa-check-circle';
const terminatedIcon = 'terminated-icon fa fa-ban';
const runningIcon = 'running-icon fa fa-cog fa-spin';

const simulationStatus = {
  RUNNING: 1,
  COMPLETE: 2,
  TERMINATED: 3,
};

type Props = {
  SimulationID: string,
  CohortID: number,
  StartTime: string,
  Status: number,
  Duration: number,
  onClickHandler: Function
}

export default function SimulationPreviewPanel(props: Props) {
  let statusIcon = completeIcon;
  if (props.Status === simulationStatus.RUNNING) {
    statusIcon = runningIcon;
  } else if (props.Status === simulationStatus.TERMINATED) {
    statusIcon = terminatedIcon;
  }

  return (
    <tr>
      <td>{props.SimulationID} </td>
      <td>
        <Link to={`/cohorts/${props.CohortID} `}>
          {props.CohortID}
        </Link>
      </td>
      <td>{props.StartTime} </td>
      <td>{props.Duration} minutes</td>
      <td>
        <span className="icon" >
          <i className={statusIcon} />
        </span>
      </td>
      <td onClick={() => props.onClickHandler(props.SimulationID)}><a>{'View Details'}</a></td>
    </tr>
  );
}



/** WEBPACK FOOTER **
 ** ./src/js/views/dashboard/simulation/SimulationPreviewPanel.jsx
 **/